import  { useRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Timer from "./cl_Timer";
import {
  setErrorMessage,
  setOtpError,
  setOtpSuccess,
  setSignupSuccess,
  signUp,
  handleRegisterOtp,
} from "./cl_SignUpSlice";
import {  useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import {
  setResetErrorMessage,
} from "../resetpage/cl_SetNewPinSlice";
import {
  handleReset,
  setResetOtpScreen,
} from "../resetpage/cl_ResetSlice";
import SetNewPin from "../resetpage/SetNewPin";

function OTPScreen(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    phoneNumber,
    pin,
    referralCode,
    otpSuccess,
    token,
    otpError,
    errorMessage,
    labelCheck,
    otpLoader,
    affiliateCode,
  } = useSelector((state) => state?.signUp);
  const {  resetOtpScreen, mobileNumber } = useSelector(
    (state) => state.resetPage
  );
  const { resetErrorMessage } = useSelector((state) => state.setNewPin);
  const dispatch = useDispatch();
  const [otp, setOTP] = useState(["", "", "", "", "", ""]);
  const inputRefs = [
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
  ];

  useEffect(() => {
    if (location?.pathname === "/resetotpscreen") {
      dispatch(setResetOtpScreen(true));
    } else {
      dispatch(setResetOtpScreen(false));
    }
  }, [location?.pathname]);
  const [showTimer, setShowTimer] = useState(true);
  const [time, setTime] = useState(60);

  useEffect(() => {
    if (time === 0) {
      setShowTimer(false);
      return;
    }

    const interval = setInterval(() => {
      setTime((prevTime) => prevTime - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [time]);

  const handleResendOTP = () => {
    setShowTimer(true);
    dispatch(setErrorMessage(""));
    dispatch(setOtpError(""));
    setOTP(["", "", "", "", "", ""]);
    setTime(60);
    setResendOTP(true);
    if (resetOtpScreen) {
      dispatch(setResetErrorMessage(""));
      dispatch(handleReset(mobileNumber, navigate));
    } else {
      dispatch(handleRegisterOtp(phoneNumber));
    }
  };

  useEffect(() => {
    dispatch(setErrorMessage(""));
    dispatch(setOtpError(""));
    setOTP(["", "", "", "", "", ""]);
  }, []);

  const handleRegister = () => {
    if (otpLoader) return;
    const latesOTP = otp.join("");
    if (latesOTP === "" || latesOTP === null) {
      dispatch(setErrorMessage("Please enter a valid 6-digit OTP"));
    } else if (latesOTP.length < 6) {
      dispatch(setErrorMessage("Please enter a valid 6-digit OTP"));
    } else {
      dispatch(
        signUp(
          latesOTP,
          phoneNumber,
          pin,
          token,
          labelCheck,
          referralCode,
          affiliateCode
        )
      );
    }
  };
  const handleInputChange = (index, event) => {
    const { value } = event.target;
    dispatch(setResetErrorMessage(""));
    dispatch(setErrorMessage(""));
    dispatch(setOtpError(""));
    if (event.keyCode === 8 && value === "") {
      if (index > 0) {
        inputRefs[index - 1].current.focus();
        const newOTP = [...otp];
        newOTP[index - 1] = "";
        setOTP(newOTP);
      }
      return;
    }
    const numericValue = value.replace(/\D/g, "");

    const newOTP = [...otp];
    newOTP[index] = numericValue;
    if (numericValue !== "" && index < inputRefs.length - 1) {
      inputRefs[index + 1].current.focus();
    }
    setOTP(newOTP);
  };
  const handleBackspace = (index, event) => {
    if (event.key === "Backspace" && index > 0 && otp[index] === "") {
      inputRefs[index - 1].current.focus();
    }
    if (event.key === "Enter") {
      !resetOtpScreen && !otpLoader && handleRegister();
    }
  };
  const [resendOTP, setResendOTP] = useState(false);
  const handleMobChange = () => {
    dispatch(setErrorMessage(""));
    if (resetOtpScreen) {
      navigate(`/resetpage?mbNum=${mobileNumber}`);
    } else {
      props?.setChange(true);
      dispatch(setOtpSuccess(false));
      dispatch(setSignupSuccess(false));
    }
  };

  useEffect(() => {
    dispatch(setErrorMessage(""));
  }, []);
  return (
    <div id="enterOTP">
      <div className="SB-loginRegister-title">Enter OTP</div>
      <div className="SB-OTPSent-container">
        OTP is sent to{" "}
        <b>
          +254{""} {resetOtpScreen ? mobileNumber : phoneNumber}
        </b>{" "}
        <a onClick={handleMobChange}>Change</a>
      </div>
      <div className="SB-loginRegister-form">
        <div className="SB-form-group">
          <div className="SB-form-label">OTP</div>
          <div className="SB-form-OTP-control">
            <div className="SB-form-control">
              {otp.map((value, index) => (
                <input
                  key={index}
                  type={"tel"}
                  placeholder=""
                  value={value}
                  maxLength={1}
                  required
                  onChange={(event) => handleInputChange(index, event)}
                  onKeyDown={(event) => handleBackspace(index, event)}
                  ref={inputRefs[index]}
                  // onKeyPress={(e) => handleKeyPress(e)}
                />
              ))}
            </div>
            <div className="SB-resend-container">
              <div>
                <span> Didn't receive OTP? </span>
                <a
                  className={`SB-resend-OTP ${showTimer ? "" : "active"}`}
                  onClick={handleResendOTP}
                >
                  Resend
                </a>
              </div>
              {showTimer && (
                <div>
                  <Timer reset={() => setResendOTP(true)} time={60} /> sec
                </div>
              )}
            </div>
          </div>
          {resetErrorMessage && (
            <div className="SB-form-errorMsg text-center">
              <span>
                {resetErrorMessage === "OTP_EXPIRED"
                  ? "In-Valid OTP"
                  : resetErrorMessage}
              </span>
            </div>
          )}
          <div className="SB-form-errorMsg text-center">
            <span>{errorMessage}</span>
            <span>{otpError && otpError}</span>
          </div>
        </div>
        {resetOtpScreen ? <SetNewPin otp={otp} /> : ""}

        {resetOtpScreen ? (
          ""
        ) : (
          <button
            className="btn SB-btnSecondary SB-btnLarge active"
            onClick={handleRegister}
            disabled={otpLoader}
          >
            {otpLoader ? (
              <div className="SB-loader-container">
                <div className="SB-loader"></div>
              </div>
            ) : (
              <div className="SB-btnTxt">Register</div>
            )}
          </button>
        )}
      </div>
    </div>
  );
}

export default OTPScreen;
